export function resolveAsOfDateCutoffIso(dateYmd: string, timeHm?: string | null): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateYmd.trim());
  if (!match) {
    throw new Error('Invalid as-of date');
  }
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const time = timeHm?.trim() ?? '';
  if (time) {
    const timeMatch = /^(\d{1,2}):(\d{2})$/.exec(time);
    if (!timeMatch) {
      throw new Error('Invalid as-of time');
    }
    const hour = Number(timeMatch[1]);
    const minute = Number(timeMatch[2]);
    return new Date(year, month - 1, day, hour, minute, 0, 0).toISOString();
  }
  return new Date(year, month - 1, day, 23, 59, 59, 999).toISOString();
}

export function parseAsOfDateCutoffIso(iso: string): { dateYmd: string; timeHm: string } {
  const cutoff = new Date(iso);
  if (Number.isNaN(cutoff.getTime())) {
    throw new Error('Invalid as-of date');
  }
  const dateYmd = [
    cutoff.getFullYear(),
    String(cutoff.getMonth() + 1).padStart(2, '0'),
    String(cutoff.getDate()).padStart(2, '0'),
  ].join('-');
  const isEndOfDay =
    cutoff.getHours() === 23 &&
    cutoff.getMinutes() === 59 &&
    cutoff.getSeconds() === 59;
  if (isEndOfDay) {
    return { dateYmd, timeHm: '' };
  }
  const timeHm = [
    String(cutoff.getHours()).padStart(2, '0'),
    String(cutoff.getMinutes()).padStart(2, '0'),
  ].join(':');
  return { dateYmd, timeHm };
}
